import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./PersonalInfo.css";
import { Info, Upload } from "../../icons";
import { useMediaQuery } from "react-responsive";
import { UpdateMyPage } from "../../services/btc-api.service";
import { useSelector } from "react-redux";

export default function PersonalInfo() {
  const user = useSelector((state) => state.user.user);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedAlternateCountryCode, setAlternateSelectedCountryCode] =
    useState("");
  const [firstName, setFirstName] = useState("");
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [alternateContactNumber, setAlternateContactNumber] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState("");
  const [port, setport] = useState("");
  const [destinationCountry, setDestinationCountry] = useState("");
  const [tradeTermOptions, setTradeTermOPtions] = useState("");
  const [errors, setErrors] = useState({});

  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (user) {
      setFirstName(user.firstName);
      setLastName(user.lastName);
      setEmail(user.email);
      setAlternateContactNumber(user.secondaryContactNumber);
      setBusinessName(user.businessName);
      setCity(user.city);
      setCountry(user.country);
      setZipCode(user.zipCode);
      setState(user.state);
      setContactNumber(user.contactNumber);
      setDestinationCountry(user.shippingCountry);
      setSelectedDateOfBirth(new Date(user.dob));
      setSelectedOptions(user.businessTypes);
      setStreetAddress(user.streetAddress);
      setSelectedImage(user.businessCard);
      setTradeTermOPtions(user.tradeTerm);
      setport(user.port);
      setSelectedShippingMethod(user.shippingMethod);
    }
  }, [user]);

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("file", file);

    fetch(process.env.REACT_APP_BTC_API_URL + "/", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setSelectedImage(
          `${process.env.REACT_APP_BTC_API_URL}/${data.data.flag}`
        );
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };
  const handleOptionSelect = (selectedValue) => {
    if (selectedValue) {
      setSelectedOptions((prevSelectedOptions) => [
        ...prevSelectedOptions,
        selectedValue,
      ]);
    }
  };
  const handleRemoveOption = (indexToRemove) => {
    const newArr = selectedOptions.filter(
      (_, index) => index !== indexToRemove
    );

    setSelectedOptions([...newArr]);
  };

  const countryCodes = [
    {
      name: "Canada",
      dial_code: "+1",
      code: "CA",
    },
    {
      name: "Cayman Islands",
      dial_code: "+345",
      code: "KY",
    },
    {
      name: "China",
      dial_code: "+86",
      code: "CN",
    },
    {
      name: "Afghanistan",
      dial_code: "+93",
      code: "AF",
    },
    {
      name: "Aland Islands",
      dial_code: "+358",
      code: "AX",
    },
    {
      name: "Denmark",
      dial_code: "+45",
      code: "DK",
    },
    {
      name: "Hong Kong",
      dial_code: "+852",
      code: "HK",
    },
    {
      name: "Iceland",
      dial_code: "+354",
      code: "IS",
    },
    {
      name: "India",
      dial_code: "+91",
      code: "IN",
    },
    {
      name: "Indonesia",
      dial_code: "+62",
      code: "ID",
    },
    {
      name: "Ireland",
      dial_code: "+353",
      code: "IE",
    },
    {
      name: "Italy",
      dial_code: "+39",
      code: "IT",
    },
    {
      name: "Japan",
      dial_code: "+81",
      code: "JP",
    },
    {
      name: "Kuwait",
      dial_code: "+965",
      code: "KW",
    },
    {
      name: "Mexico",
      dial_code: "+52",
      code: "MX",
    },
    {
      name: "Norway",
      dial_code: "+47",
      code: "NO",
    },
    {
      name: "Oman",
      dial_code: "+968",
      code: "OM",
    },
    {
      name: "Pakistan",
      dial_code: "+92",
      code: "PK",
    },
    {
      name: "Poland",
      dial_code: "+48",
      code: "PL",
    },
    {
      name: "Portugal",
      dial_code: "+351",
      code: "PT",
    },
    {
      name: "Romania",
      dial_code: "+40",
      code: "RO",
    },
    {
      name: "Russia",
      dial_code: "+7",
      code: "RU",
    },
  ];

  const handleCountryCodeChange = (e) => {
    setSelectedCountryCode(e.target.value);
  };
  const [selectedDateOfBirth, setSelectedDateOfBirth] = useState("");

  const handleDateOfBirthChange = (date) => {
    setSelectedDateOfBirth(date);
  };
  const handleShippingMethodChange = (event) => {
    const { value } = event.target;
    setSelectedShippingMethod(value);
  };

  const userProfile = async () => {
    await UpdateMyPage({
      firstName: firstName,
      lastName: lastName,
      dob: selectedDateOfBirth,
      streetAddress: streetAddress,
      contactNumber: contactNumber,
      secondaryContactNumber: alternateContactNumber,
      zipCode: zipCode,
      city: city,
      state: state,
      country: country,
      businessName: businessName,
      businessTypes: selectedOptions,
      businessCard: selectedImage,
      tradeTerm: tradeTermOptions,
      shippingMethod: selectedShippingMethod,
      port: port,
      shippingCountry: destinationCountry,
      userId: user._id,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!firstName) newErrors.firstName = "First name is required.";
    if (!lastName) newErrors.lastName = "Last name is required.";
    if (!email) newErrors.email = "Email is required.";
    if (!selectedDateOfBirth)
      newErrors.selectedDateOfBirth = "Date Of Birth is required.";
    if (!contactNumber) newErrors.contactNumber = "Contact number is required.";
    if (!alternateContactNumber)
      newErrors.alternateContactNumber =
        "Alternate Contact number is required.";
    if (!streetAddress) newErrors.streetAddress = "Street Address is required.";
    if (!zipCode) newErrors.zipCode = "Zip code is required.";
    if (!city) newErrors.city = "city Name is required.";
    if (!country) newErrors.country = "country Name is required.";
    if (!state) newErrors.state = "state Name is required.";
    if (!businessName) newErrors.businessName = " business Name is required.";
    if (!port) newErrors.port = "port is required.";
    if (!destinationCountry)
      newErrors.destiantionCountry = "destination country is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      userProfile();
    }
  };

  return (
    <div className="container">
      <form className="formStyle" onSubmit={handleSubmit}>
        <div>
          <p className="my-profile-info" style={{ marginTop: 40 }}>
            Personal Information
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-4">
            <input
              type="text"
              placeholder="First Name"
              className={`border ${
                errors.firstName ? "border-danger" : "border-secondary"
              } rounded form-control p-3 `}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            {errors.firstName && (
              <p className="text-danger">{errors.firstName}</p>
            )}
          </div>
          <div className="col-12 col-md-4 col-lg-4">
            <input
              type="text"
              placeholder="Last Name"
              className={`border ${
                errors.lastName ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            {errors.lastName && (
              <p className="text-danger">{errors.lastName}</p>
            )}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-4">
            <DatePicker
              selected={selectedDateOfBirth}
              value={selectedDateOfBirth}
              placeholderText="Date of Birthday"
              onChange={handleDateOfBirthChange}
              className={`border ${
                errors.dateOfBirth ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
            />
            {errors.selectedDateOfBirth && (
              <p className="text-danger">{errors.selectedDateOfBirth}</p>
            )}
          </div>
          <div className="col-12 col-md-4 col-lg-4">
            <input
              type="text"
              placeholder="Email"
              className={`border ${
                errors.email ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <p className="text-danger">{errors.email}</p>}
          </div>
        </div>
        <div className="row justify-content-center ">
          <div className="col-3 col-md-1 col-lg-1 ">
            <select
              className="border border-secondary rounded code countrycodeStyle"
              value={selectedCountryCode}
              onChange={handleCountryCodeChange}
            >
              {countryCodes.map((country) => (
                <option key={country.dial_code} value={country.dial_code}>
                  {country.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div className="col-9 col-md-10 col-lg-3">
            <input
              type="text"
              placeholder="Contact NO."
              className={`border ${
                errors.contactNumber ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
            />
            {errors.contactNumber && (
              <p className="text-danger">{errors.contactNumber}</p>
            )}
          </div>
          <div className="col-3 col-md-1 col-lg-1 ">
            <select
              className="border border-secondary rounded code countrycodeStyle "
              value={selectedAlternateCountryCode}
              onChange={(e) => setAlternateSelectedCountryCode(e.target.value)}
            >
              {countryCodes.map((country) => (
                <option key={country.dial_code} value={country.dial_code}>
                  {country.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div className="col-9 col-md-10 col-lg-3">
            <input
              type="text"
              placeholder="Alternate Contact NO."
              className={`border ${
                errors.alternateContactNumber
                  ? "border-danger"
                  : "border-secondary"
              } rounded form-control p-3`}
              value={alternateContactNumber}
              onChange={(e) => setAlternateContactNumber(e.target.value)}
            />
            {errors.alternateContactNumber && (
              <p className="text-danger">{errors.alternateContactNumber}</p>
            )}
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-6">
            <input
              type="text"
              placeholder="Street Address"
              className={`border ${
                errors.streetAddress ? "border-danger" : "border-secondary"
              } rounded form-control streetAddress p-3`}
              value={streetAddress}
              onChange={(e) => setStreetAddress(e.target.value)}
            />
            {errors.streetAddress && (
              <p className="text-danger">{errors.streetAddress}</p>
            )}
          </div>
          <div className="col-12 col-md-10 col-lg-2">
            <input
              type="text"
              placeholder="Zip Code"
              className={`border ${
                errors.zipCode ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
            />
            {errors.zipCode && <p className="text-danger">{errors.zipCode}</p>}
          </div>
        </div>
        <div className="row justify-content-center p-2 inputpadding">
          <div className="col-12 col-md-8 col-lg-8">
            {" "}
            <div className="row">
              {" "}
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className={`border ${
                    errors.city ? "border-danger" : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.city && <p className="text-danger">{errors.city}</p>}
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="State"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  className={`border ${
                    errors.state ? "border-danger" : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.state && <p className="text-danger">{errors.state}</p>}
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  placeholder="Country"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  className={`border ${
                    errors.country ? "border-danger" : "border-secondary"
                  } rounded-lg form-control corner-border p-3`}
                />
                {errors.country && (
                  <p className="text-danger">{errors.country}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <p className="my-profile-info">Business Information</p>

        <div className="row justify-content-center">
          <div className="col-12 col-md-5 col-lg-4">
            <input
              type="text"
              placeholder="Business Name"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              className={`border ${
                errors.businessName ? "border-danger" : "border-secondary"
              } rounded form-control p-3`}
            />
            {errors.businessName && (
              <p className="text-danger">{errors.businessName}</p>
            )}
          </div>
          <div className="col-12 col-md-5 col-lg-4">
            <div className="form-group ">
              <select
                id="languages"
                className="border border-secondary rounded p-3"
                value={selectedOptions}
                onChange={(e) => handleOptionSelect(e.target.value)}
              >
                <option value="">Business type</option>
                <option value="All type">All type</option>
                <option value="Damage Car">Damage Car</option>
                <option value="Used Car">Used Car</option>
                <option value="Truck">Truck</option>
                <option value="Forklift">Forklift</option>
                <option value="Construction Machinery">
                  Construction Machinery
                </option>
                <option value="Industrial Machinery">
                  Industrial Machinery{" "}
                </option>
                <option value="Form Machinery">Form Machinery</option>
                <option value="Parts">Parts</option>
              </select>
              <div>
                {selectedOptions.map((option, index) => (
                  <div key={index} className="chip">
                    <span className="chip-text">{option}</span>
                    <button
                      type="button"
                      className="chip-button"
                      onClick={() => handleRemoveOption(index)}
                    >
                      <span
                        role="img"
                        aria-label="Remove"
                        style={{ color: "gray" }}
                      >
                        ✕
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2 justify-content-center">
          <div className="col-12 col-md-5 col-lg-4">
            <div class="form-container3">
              <div className="image-upload-container p-3">
                <label htmlFor="image-upload" className="upload-label">
                  {selectedImage ? (
                    <img
                      src={selectedImage}
                      alt={"Business Card"}
                      className="uploaded-image"
                    />
                  ) : (
                    <div className="upload-placeholder">
                      <span>
                        <Upload />
                        Upload Business Card
                      </span>
                    </div>
                  )}
                </label>

                <input
                  type="file"
                  id="image-upload"
                  accept="image/*"
                  onChange={handleImageChange}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-5 col-lg-4 mt-2">
            <select
              className="border border-secondary rounded p-3"
              value={tradeTermOptions}
              onChange={(e) => setTradeTermOPtions(e.target.value)}
            >
              <option disabled={false} value="">
                Trade Term
              </option>
              <option value="C&F">C&F</option>
              <option value="C&I">C&I</option>
              <option value="CIF">CIF</option>
            </select>
            <div className="shippingMethodresp">
              <span className="personal-info-shipment ">
                Shipping Method <Info className="infoIcon-personal" />
              </span>
              <div className=" d-flex">
                <label htmlFor="container">
                  <input
                    type="radio"
                    value="container"
                    checked={selectedShippingMethod === "container"}
                    onChange={handleShippingMethodChange}
                    name="quality"
                    id="container"
                    className="radio-default"
                  />{" "}
                  <span>Container</span>
                </label>
                <div className="mx-3"></div>
                <label htmlFor="roro">
                  <input
                    type="radio"
                    value="roro"
                    checked={selectedShippingMethod === "roro"}
                    onChange={handleShippingMethodChange}
                    name="quality"
                    id="roro"
                    className="radio-default"
                  />{" "}
                  <span>Roll off/Roll on</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {isMobile === false && (
          <div>
            <span className="personal-info-Destination">Destination</span>
            <div className="row justify-content-center">
              <div className="col-12 col-md-5 col-lg-4">
                <input
                  type="text"
                  placeholder="Port"
                  value={port}
                  onChange={(e) => setport(e.target.value)}
                  className={`border ${
                    errors.port ? "border-danger" : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.port && <p className="text-danger">{errors.port}</p>}
              </div>
              <div className="col-12 col-md-5 col-lg-4">
                <input
                  type="text"
                  placeholder="Country"
                  value={destinationCountry}
                  onChange={(e) => setDestinationCountry(e.target.value)}
                  className={`border ${
                    errors.destiantionCountry
                      ? "border-danger"
                      : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.destiantionCountry && (
                  <p className="text-danger">{errors.destiantionCountry}</p>
                )}
              </div>

              <div className="d-flex justify-content-center align-items-center vh-10">
                <div className="row">
                  <div className="col-12 col-md-4 col-lg-4">
                    <button type="submit" className="buttonstyle">
                      Update Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isMobile && (
          <div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-5 col-lg-4">
                <input
                  type="text"
                  placeholder="Destination Port"
                  value={port}
                  onChange={(e) => setport(e.target.value)}
                  className={`border ${
                    errors.port ? "border-danger" : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.port && <p className="text-danger">{errors.port}</p>}
              </div>
              <div className="col-12 col-md-5 col-lg-4">
                <input
                  type="text"
                  placeholder="Destination Country"
                  value={destinationCountry}
                  onChange={(e) => setDestinationCountry(e.target.value)}
                  className={`border ${
                    errors.destiantionCountry
                      ? "border-danger"
                      : "border-secondary"
                  } rounded form-control p-3`}
                />
                {errors.destiantionCountry && (
                  <p className="text-danger">{errors.destiantionCountry}</p>
                )}
              </div>

              <div className="d-flex justify-content-center align-items-center vh-10">
                <div className="row">
                  <div className="col-12 col-md-5 col-lg-4  ">
                    <button type="submit" className="buttonstyle-8">
                      Update Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
      <div style={{ marginBottom: 200 }}></div>
    </div>
  );
}
